import { createFileRoute } from '@tanstack/react-router';
import { motion } from 'motion/react';

import classes from './$chatSessionId.module.css';
import { Chat } from '#components/chat';
import { ChatProvider } from '#components/chat/contexts/ChatProvider';
import { useChatSession } from '#hooks/useChatSession';

export const Route = createFileRoute('/ai/$chatSessionId')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <motion.div className={classes.content} layout>
      <ChatSession />
    </motion.div>
  );
}

function ChatSession() {
  const { chatSessionId } = Route.useParams();
  const session = useChatSession(chatSessionId);

  return (
    <div className={classes.chat}>
      <ChatProvider session={session}>
        <Chat />
      </ChatProvider>
    </div>
  );
}
